export const heroData = {
  tag: "每日更新 · 极速播放",
  siteName: "天美麻花星空影视免费观看",
  corePosition: "全网高清影视 · 流畅不缓冲",
  slogans: ["海量片库随心看", "无广告纯净观影体验"],
  description:
    "天美麻花星空影视免费观看为您提供麻花星空影视全网最新最全的高清影视资源。涵盖电影、电视剧、综艺、动漫等全类型内容，采用极速CDN分发技术，确保720P至4K画质流畅播放不卡顿。每日更新海内外热门大片，无需注册即可免费在线观看，是您休闲娱乐的优质选择。",
  stats: [
    { label: "每日更新", value: "50+部" },
    { label: "高清片源", value: "10万+" },
    { label: "极速线路", value: "99.9%可用" },
  ],
  primaryCta: { text: "立即观影", href: "#index" },
  secondaryCta: { text: "热门排行", href: "#ranking" },
};

export const cardsData = [
  {
    title: "热门电影大片抢先看",
    desc: "国内外最新上映大片同步上线，高清画质还原影院级观影体验，支持多线路切换保证流畅播放。",
    image: "https://readdy.ai/api/search-image?query=cinematic%20movie%20poster%20collage%20with%20film%20reel%20and%20spotlight%2C%20dark%20atmospheric%20theater%20background%2C%20dramatic%20lighting%20with%20warm%20golden%20tones%2C%20movie%20entertainment%20theme%2C%20professional%20photography&width=800&height=500&seq=card-movie-01&orientation=landscape",
    tag: "电影",
    date: "2026-07-30",
  },
  {
    title: "热播电视剧每日更新",
    desc: "国产剧、韩剧、美剧、日剧一网打尽，同步各大平台更新进度，追剧追到过瘾。",
    image: "https://readdy.ai/api/search-image?query=modern%20living%20room%20with%20large%20TV%20screen%20showing%20drama%20series%2C%20cozy%20atmosphere%20with%20warm%20ambient%20lighting%2C%20entertainment%20scene%2C%20dark%20themed%20interior&width=800&height=500&seq=card-tv-02&orientation=landscape",
    tag: "电视剧",
    date: "2026-07-29",
  },
  {
    title: "热门综艺爆笑不断",
    desc: "明星真人秀、脱口秀、音乐竞演、户外探险等热门综艺节目全集收录，笑点密集精彩不停。",
    image: "https://readdy.ai/api/search-image?query=variety%20show%20stage%20with%20colorful%20lights%20and%20confetti%2C%20entertainment%20studio%20set%2C%20dynamic%20atmosphere%2C%20warm%20stage%20lighting%2C%20professional%20production%20photography&width=800&height=500&seq=card-variety-03&orientation=landscape",
    tag: "综艺",
    date: "2026-07-28",
  },
  {
    title: "经典动漫回忆杀",
    desc: "国漫崛起与日漫经典全收录，从热血战斗到治愈日常，高清重制版带来全新观看体验。",
    image: "https://readdy.ai/api/search-image?query=anime%20art%20style%20illustration%20with%20vibrant%20colors%2C%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic%2C%20cinematic%20lighting%2C%20action%20scene%20atmosphere&width=800&height=500&seq=card-anime-04&orientation=landscape",
    tag: "动漫",
    date: "2026-07-27",
  },
  {
    title: "纪录片探索世界",
    desc: "BBC、Discovery等顶级纪录片频道精选，自然、历史、科技主题高清呈现，足不出户看世界。",
    image: "https://readdy.ai/api/search-image?query=stunning%20nature%20documentary%20scene%20with%20wildlife%20animals%2C%20cinematic%20wide%20angle%2C%20professional%20nature%20photography%2C%20warm%20golden%20hour%20light%2C%20atmospheric%20landscape&width=800&height=500&seq=card-doc-05&orientation=landscape",
    tag: "纪录片",
    date: "2026-07-26",
  },
  {
    title: "少儿专区寓教于乐",
    desc: "精选优质动画和教育内容，安全健康的观影环境，让孩子在欢乐中学习成长。",
    image: "https://readdy.ai/api/search-image?query=colorful%20playful%20childrens%20room%20with%20educational%20toys%20and%20books%2C%20bright%20warm%20lighting%2C%20cheerful%20atmosphere%2C%20creative%20play%20space%2C%20professional%20interior%20photography&width=800&height=500&seq=card-kids-06&orientation=landscape",
    tag: "少儿",
    date: "2026-07-25",
  },
  {
    title: "4K超清专区震撼体验",
    desc: "精选4K超高清片源，配合HDR色彩增强技术，让每一帧画面都细腻动人，沉浸式观影享受。",
    image: "https://readdy.ai/api/search-image?query=ultra%20HD%204K%20display%20showing%20stunning%20cinematic%20landscape%2C%20vibrant%20HDR%20colors%2C%20modern%20home%20theater%20setup%2C%20dark%20room%20with%20ambient%20backlighting%2C%20professional%20product%20photography&width=800&height=500&seq=card-4k-07&orientation=landscape",
    tag: "4K专区",
    date: "2026-07-24",
  },
];

export const appData = {
  title: "手机看片更便捷",
  desc: "天美麻花星空影视移动端适配完美，支持手机浏览器直接访问。高清流畅播放，随时随地想看就看，通勤、休息、旅行不再无聊。",
  features: ["免安装即开即看", "流量优化省带宽", "全屏手势操作", "记忆播放进度"],
  image: "https://readdy.ai/api/search-image?query=smartphone%20displaying%20movie%20streaming%20interface%20on%20dark%20background%2C%20modern%20mobile%20device%20mockup%2C%20clean%20minimal%20design%2C%20cinematic%20app%20UI%2C%20professional%20product%20photography%20with%20soft%20lighting&width=600&height=900&seq=app-mobile-01&orientation=portrait",
};

export const aboutData = {
  title: "关于天美麻花星空影视",
  subtitle: "为影迷打造极致免费的观影平台",
  paragraphs: [
    "天美麻花星空影视免费观看（麻花星空影视）是一个专注于提供高清流畅在线观影服务的免费平台。我们致力于为广大影迷朋友打造一个内容丰富、画质出色、播放流畅的在线影院。",
    "平台汇聚了来自全球的海量影视资源，涵盖动作、喜剧、科幻、爱情、悬疑、恐怖等全类型电影，以及国产、韩剧、美剧、日剧等热门电视剧。同时，综艺娱乐、动漫番剧、纪录片等特色内容持续更新。",
    "我们采用先进的分布式CDN加速技术，多线路智能切换确保播放不缓冲不卡顿。支持720P至4K多清晰度选择，适配不同网络环境下的观看需求。无需注册登录，打开即看，纯净无广告干扰。",
    "每日专业编辑团队精心筛选推荐，热门榜单实时更新，让您不错过任何一部好片。天美麻花星空影视——您身边最贴心的免费影视伙伴。",
  ],
  image: "https://readdy.ai/api/search-image?query=modern%20minimalist%20home%20theater%20room%20with%20large%20projector%20screen%2C%20comfortable%20seating%2C%20warm%20ambient%20lighting%2C%20dark%20walls%2C%20cinematic%20atmosphere%2C%20professional%20interior%20photography&width=800&height=600&seq=about-cinema-01&orientation=landscape",
};

export const updatesData = [
  {
    date: "2026-07-31",
    title: "《星际穿越2》4K重制版上线",
    desc: "经典科幻巨作4K修复版正式登陆，HDR色彩增强让太空场景更加震撼，多线路极速播放。",
    tag: "上新",
  },
  {
    date: "2026-07-30",
    title: "暑期档热门电影专题上线",
    desc: "暑期档多部国产大片专题合集，包含动作、喜剧、动画等类型，陪伴你度过炎炎夏日。",
    tag: "专题",
  },
  {
    date: "2026-07-28",
    title: "播放线路全面升级",
    desc: "新增三条极速CDN线路，覆盖全国各大区域，播放缓冲率降低至0.1%以下。",
    tag: "优化",
  },
  {
    date: "2026-07-25",
    title: "《时光代理人》第二季独家上线",
    desc: "高分国产动画续作归来，悬疑剧情再次升级，首集即可免费观看全集。",
    tag: "独家",
  },
  {
    date: "2026-07-22",
    title: "韩剧专区大更新",
    desc: "多部最新韩剧同步韩国播出进度，《黑暗荣耀》系列全集高清收录。",
    tag: "更新",
  },
  {
    date: "2026-07-18",
    title: "移动端体验优化完成",
    desc: "手机浏览器访问体验大幅提升，新增手势控制和记忆播放功能，看片更舒适。",
    tag: "优化",
  },
  {
    date: "2026-07-15",
    title: "纪录片《地球脉动III》中配版上线",
    desc: "BBC顶级自然纪录片第三季中文配音版正式上线，4K超清画质感受自然之美。",
    tag: "上新",
  },
];

export const indexData = [
  { title: "动作大片", count: "328部", icon: "ri-sword-line", color: "accent" },
  { title: "喜剧电影", count: "256部", icon: "ri-emotion-laugh-line", color: "primary" },
  { title: "科幻巨制", count: "189部", icon: "ri-rocket-line", color: "secondary" },
  { title: "爱情剧场", count: "312部", icon: "ri-heart-line", color: "accent" },
  { title: "悬疑推理", count: "175部", icon: "ri-search-eye-line", color: "primary" },
  { title: "恐怖惊悚", count: "143部", icon: "ri-ghost-line", color: "secondary" },
  { title: "国剧精选", count: "467部", icon: "ri-tv-line", color: "accent" },
  { title: "热门综艺", count: "218部", icon: "ri-mic-line", color: "primary" },
  { title: "动漫番剧", count: "534部", icon: "ri-palette-line", color: "secondary" },
];

export const faqData = [
  {
    q: "天美麻花星空影视是否真的完全免费？",
    a: "是的，天美麻花星空影视免费观看平台所有内容均为免费，无需注册、无需付费、无需会员。我们通过优化运营成本，为广大用户提供零门槛的观影体验。",
  },
  {
    q: "为什么有时候播放会卡顿？如何解决？",
    a: "如遇卡顿可以尝试以下方法：点击播放器右下角切换播放线路；降低清晰度从4K切换到1080P；检查本地网络连接状态。我们提供多条CDN线路保证99.9%的可用率。",
  },
  {
    q: "支持哪些设备观看？需要安装APP吗？",
    a: "支持电脑、平板、手机等所有主流设备，直接在浏览器中打开即可观看，无需下载安装任何APP或插件。推荐使用Chrome、Safari等现代浏览器获得最佳体验。",
  },
  {
    q: "影片更新频率如何？新片多久上线？",
    a: "平台每日更新50+部新内容，热门院线电影下映后通常1-3个月内上线高清版本。电视剧和综艺保持与播出平台同步更新的节奏，确保您不错过任何精彩内容。",
  },
  {
    q: "平台上的影片画质如何？有中文字幕吗？",
    a: "大部分影片提供720P至4K多清晰度选择，默认采用1080P高清画质。海外影视内容均配备专业中文字幕，部分热门影片还提供双语字幕和国语音轨。",
  },
];

export const carouselData = [
  {
    title: "《星际迷航：新纪元》",
    subtitle: "年度科幻巨制 · 4K HDR",
    desc: "人类探索宇宙边疆的史诗冒险，视觉特效全面升级，沉浸式太空之旅等你启程。",
    image: "https://readdy.ai/api/search-image?query=epic%20science%20fiction%20space%20scene%20with%20spaceship%20and%20nebula%2C%20cinematic%20lighting%2C%20deep%20space%20background%20with%20stars%2C%20dramatic%20atmosphere%2C%20movie%20poster%20style&width=1200&height=600&seq=carousel-scifi-01&orientation=landscape",
    tag: "科幻",
    rating: "9.2",
  },
  {
    title: "《长安十二时辰》电影版",
    subtitle: "古装悬疑巅峰 · 影院级画质",
    desc: "盛世长安暗流涌动，十二时辰生死追击，恢弘场景再现大唐风华。",
    image: "https://readdy.ai/api/search-image?query=ancient%20Chinese%20city%20at%20night%20with%20lanterns%20and%20traditional%20architecture%2C%20Tang%20Dynasty%20aesthetic%2C%20cinematic%20atmosphere%2C%20warm%20golden%20lighting%2C%20historical%20drama%20style&width=1200&height=600&seq=carousel-ancient-02&orientation=landscape",
    tag: "古装",
    rating: "8.9",
  },
  {
    title: "《深海之光》",
    subtitle: "国产动画新标杆 · 治愈力作",
    desc: "一段深海奇遇的奇幻旅程，画面美轮美奂，故事温暖人心，年度动画黑马。",
    image: "https://readdy.ai/api/search-image?query=beautiful%20underwater%20fantasy%20scene%20with%20bioluminescent%20creatures%2C%20deep%20ocean%20with%20light%20rays%2C%20magical%20atmosphere%2C%20animated%20film%20aesthetic%2C%20dreamy%20color%20palette&width=1200&height=600&seq=carousel-anime-03&orientation=landscape",
    tag: "动画",
    rating: "9.0",
  },
  {
    title: "《极限追击》系列合集",
    subtitle: "动作爽片连播 · 肾上腺素飙升",
    desc: "经典动作系列六部连播，飙车、枪战、格斗场面不间断，周末刷片首选。",
    image: "https://readdy.ai/api/search-image?query=intense%20action%20movie%20scene%20with%20car%20chase%20in%20city%20at%20night%2C%20dramatic%20lighting%2C%20explosive%20atmosphere%2C%20cinematic%20photography%2C%20thrilling%20energy&width=1200&height=600&seq=carousel-action-04&orientation=landscape",
    tag: "动作",
    rating: "8.7",
  },
];

export const topicsData = [
  { name: "科幻电影推荐", heat: "9.8万讨论", tag: "热门" },
  { name: "国产悬疑剧", heat: "8.5万讨论", tag: "新锐" },
  { name: "韩剧追更日历", heat: "7.2万讨论", tag: "热播" },
  { name: "动漫新番导视", heat: "6.9万讨论", tag: "推荐" },
  { name: "恐怖片精选", heat: "5.6万讨论", tag: "经典" },
  { name: "纪录片必看榜", heat: "5.1万讨论", tag: "品质" },
  { name: "暑期观影指南", heat: "10.3万讨论", tag: "热门" },
  { name: "喜剧电影合集", heat: "4.8万讨论", tag: "轻松" },
  { name: "独立电影推荐", heat: "3.5万讨论", tag: "文艺" },
];

export const contactData = {
  title: "联系我们",
  subtitle: "意见反馈 · 内容建议 · 商务合作",
  desc: "如果您在使用天美麻花星空影视免费观看过程中遇到任何问题，或者有好的内容推荐建议，欢迎随时与我们取得联系。我们珍视每一位用户的反馈，致力持续提升观影体验。",
  email: "feedback@tianmeimahua.com",
  tips: ["7×24小时在线客服", "反馈将在24小时内回复", "欢迎推荐优质影片资源"],
};

export const rankingData = [
  { rank: 1, title: "《星际穿越2》", type: "科幻电影", score: "9.6", tag: "热播" },
  { rank: 2, title: "《长安十二时辰》", type: "古装剧集", score: "9.4", tag: "飙升" },
  { rank: 3, title: "《深海之光》", type: "动画电影", score: "9.3", tag: "新上" },
  { rank: 4, title: "《黑暗荣耀》全集", type: "韩剧", score: "9.2", tag: "热门" },
  { rank: 5, title: "《极限追击6》", type: "动作电影", score: "9.0", tag: "经典" },
  { rank: 6, title: "《时光代理人2》", type: "国产动画", score: "8.9", tag: "追番" },
  { rank: 7, title: "《地球脉动III》", type: "纪录片", score: "8.8", tag: "品质" },
];

export const commentsData = [
  {
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20young%20Asian%20person%2C%20neutral%20expression%2C%20clean%20white%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-01&orientation=squarish",
    name: "星辰大海",
    date: "2026-07-30",
    content: "用了天美麻花星空影视快一年了，片源是真的全！最新的电影基本都能找到，而且画质清晰，切换线路也很方便。推荐给了很多朋友，都说好用！",
    liked: true,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20Asian%20woman%2C%20friendly%20smile%2C%20clean%20studio%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-02&orientation=squarish",
    name: "小雨点点",
    date: "2026-07-28",
    content: "追剧党狂喜！韩剧更新速度跟韩国那边几乎同步，再也不用到处找资源了。播放流畅不卡，晚上高峰期也稳定，强烈推荐给爱看剧的小伙伴。",
    liked: false,
  },
  {
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20photo%20of%20young%20Asian%20man%2C%20casual%20style%2C%20clean%20white%20background%2C%20headshot%20style&width=100&height=100&seq=avatar-03&orientation=squarish",
    name: "电影狂人",
    date: "2026-07-25",
    content: "作为一个电影发烧友，这个平台的片库真的让我惊喜。经典老片的高清修复版、独立电影、冷门佳作都能找到。4K专区更是画质党的天堂！",
    liked: true,
  },
];

export const mediaData = [
  {
    title: "2026暑期档观影指南",
    subtitle: "10部必看大片推荐",
    image: "https://readdy.ai/api/search-image?query=summer%20movie%20theater%20entrance%20with%20colorful%20posters%2C%20warm%20evening%20lighting%2C%20cinematic%20atmosphere%2C%20nostalgic%20vibe%2C%20professional%20photography&width=800&height=450&seq=media-summer-01&orientation=landscape",
    duration: "15:28",
    views: "12.8万",
  },
  {
    title: "《星际穿越2》幕后花絮",
    subtitle: "导演独家深度访谈",
    image: "https://readdy.ai/api/search-image?query=film%20production%20set%20with%20professional%20camera%20equipment%2C%20green%20screen%20studio%2C%20cinematic%20lighting%20setup%2C%20behind%20the%20scenes%20atmosphere&width=800&height=450&seq=media-behind-02&orientation=landscape",
    duration: "22:15",
    views: "8.5万",
  },
  {
    title: "国产动画崛起之路",
    subtitle: "从大圣到深海",
    image: "https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20studio%20with%20drawing%20tablets%20and%20character%20designs%2C%20creative%20workspace%2C%20warm%20lighting%2C%20artistic%20atmosphere&width=800&height=450&seq=media-animation-03&orientation=landscape",
    duration: "18:42",
    views: "6.3万",
  },
  {
    title: "恐怖片为什么让人上瘾",
    subtitle: "心理学视角解读",
    image: "https://readdy.ai/api/search-image?query=dark%20cinema%20room%20with%20single%20viewer%20silhouette%2C%20dramatic%20lighting%20from%20screen%2C%20atmospheric%20shadows%2C%20mysterious%20mood%2C%20professional%20photography&width=800&height=450&seq=media-horror-04&orientation=landscape",
    duration: "12:05",
    views: "5.1万",
  },
];

export const featuresData = [
  {
    icon: "ri-speed-up-line",
    title: "极速播放",
    desc: "多CDN智能调度，全国覆盖节点，播放零等待，告别缓冲烦恼。",
  },
  {
    icon: "ri-4k-line",
    title: "高清画质",
    desc: "720P至4K多清晰度自由切换，HDR色彩增强，影院级视觉享受。",
  },
  {
    icon: "ri-shield-check-line",
    title: "纯净安全",
    desc: "无弹窗广告、无恶意跳转，纯净观影环境，保护您的隐私安全。",
  },
  {
    icon: "ri-smartphone-line",
    title: "多端适配",
    desc: "电脑、平板、手机完美适配，随时随地打开浏览器即可观看。",
  },
  {
    icon: "ri-refresh-line",
    title: "每日更新",
    desc: "专业编辑团队每日精选，50+部新内容上线，热门资源不遗漏。",
  },
];

export const footerData = {
  siteName: "天美麻花星空影视免费观看",
  slogan: "高清流畅 · 免费观影 · 每日更新",
  desc: "天美麻花星空影视（麻花星空影视）致力于为全球华语用户提供高清流畅的免费在线观影服务。海量电影、电视剧、综艺、动漫资源，无需注册、无需付费，纯净观影体验。",
  links: [
    { text: "关于我们", href: "#about" },
    { text: "常见问答", href: "#faq" },
    { text: "联系我们", href: "#contact" },
    { text: "内容索引", href: "#index" },
    { text: "热门排行", href: "#ranking" },
    { text: "观影指南", href: "#cards" },
  ],
  copyright: "© 2026 天美麻花星空影视免费观看 All Rights Reserved.",
};